import {
    NewDossierData,
    RolesEnum,
    DossierDataToUpdate,
    contractInfosToUploadType,
} from "../types";
import api from "./api";

type DossiersOptType = {
    dossierStatus?: number;
    userRoleId?: number;
    dossiersStatuses?: number[] | undefined;
    establishmentGroup?: number | null;
    region?: number | null;
};

export async function getDossiers(
    userId?: number,
    opts?: DossiersOptType
): Promise<any | null> {
    let url = "api/dossier/";
    const { userRoleId, dossiersStatuses } = opts || {};

    const getParamsByUserRole = (userRoleId: number) => {
        switch (userRoleId) {
            case RolesEnum.CLIENT:
                if (!dossiersStatuses) {
                    return `?creator_user=${userId}`;
                }
                return `?creator_user=${userId}&dossier_status=${dossiersStatuses}`;
            case RolesEnum.ADMIN:
                return dossiersStatuses
                    ? `?dossier_status=${dossiersStatuses}`
                    : "";
            case RolesEnum.INSTRUCTEUR:
                return `?assigned_user=${userId}&dossier_status=${dossiersStatuses}`;
            case RolesEnum.SYNERPA:
                return `?dossier_status=${dossiersStatuses}`;
            case RolesEnum.ADMIN_RESEAU:
                return opts?.establishmentGroup
                    ? `?establishment_group=${opts?.establishmentGroup}`
                    : "";
            case RolesEnum.ADMIN_REGION:
                return opts?.region
                    ? `?region_id=${opts?.region}`
                    : "";
            default:
                return "";
        }
    };

    if (userId && userRoleId) {
        url += getParamsByUserRole(userRoleId);
    }

    // if (dossierStatus && userId && !RolesEnum.ADMIN) {
    //     url += `&dossier_status=${dossierStatus}`;
    // }

    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function createNewDossier(
    newDossierBody: NewDossierData
): Promise<any | null> {
    let url = "api/dossier/";

    return await api
        .post(url, newDossierBody)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getDossierById(dossierId?: number): Promise<any | null> {
    let url = "api/dossier/";
    if (dossierId) {
        url += `${dossierId}`;
    }

    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getDossierStatus(): Promise<any | null> {
    const url = "api/dossier-status/";
    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function deleteDossier(dossierId: number): Promise<any | null> {
    const url = "api/dossier/" + dossierId;
    return await api
        .delete(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function updateDossier(
    dossierId: number,
    dossierPayload: DossierDataToUpdate
) {
    const url = "api/dossier/" + dossierId;
    return await api
        .patch(url, dossierPayload)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getInstructorList(): Promise<any | null> {
    let url = "api/instructor-list/";
    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function dossiersAssignment(
    dossierIds: number[],
    assigned: number
): Promise<any | null> {
    let url = "api/dossiers-assignment/";

    return await api
        .post(url, {
            dossiers: dossierIds,
            assigned,
        })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            if (response.status === 200) {
                return { ok: true };
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function downloadAllDocs(dossierId: number): Promise<any | null> {
    const url = "api/zip-dossier/" + dossierId;
    return await api
        .get(url, { responseType: "blob" })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function uploadContractService(
    contractInfosToUpload: contractInfosToUploadType
): Promise<any | null> {
    return await api
        .post("api/upload-contrat/", contractInfosToUpload, {
            headers: {
                "Content-Type":
                    "multipart/form-data; boundary=<calculated when request is sent>",
            },
        })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function generateContractService(
    dossierId: number
): Promise<any | null> {
    return await api
        .get("api/generer-contrat/" + dossierId, { responseType: "blob" })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}
